import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { isBoolean, isNumber } from '../../lib/utils'
import Chip from '../Chip/Chip'
import styles from './image.scss'

class Image extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}

    this.handleFallback = this.handleFallback.bind(this)
    this.handleLoad = this.handleLoad.bind(this)
  }

  componentDidUpdate(prevProp) {
    const { src } = this.props

    if (prevProp.src !== src) this.handleFallback(false)
  }

  handleFallback(value) {
    this.setState({ failed: isBoolean(value) ? value : true })
  }

  handleLoad() {
    this.setState({ loaded: true })
  }

  render() {
    const {
      fallback,
      loading,
      src,
      className,
      style,
      alt,
      width,
      height,
      radius,
      fluid,
      onClick,
      tag
    } = this.props

    const { loaded } = this.state

    const { failed } = this.state
    const imageStyles = {}

    let imageSrc = ''

    if (width) imageStyles.width = `${width}px`

    if (height) imageStyles.maxHeight = `${height}px`

    if (failed) imageSrc = fallback
    else if (src) {
      imageSrc = src

      if (width || height) {
        imageSrc += '?s=fill'

        if (width) imageSrc += `&w=${width}`

        if (height) imageSrc += `&h=${height}`
      }
    }

    if (radius && isNumber(radius)) imageStyles.borderRadius = `${radius}px`

    const imageClass = classNames(styles.image, className, {
      [styles.radius]: radius && isBoolean(radius)
    })

    const loadClass = classNames(styles.content, {
      [styles.loaded]: loaded,
      [styles.clickable]: onClick,
      [styles.fluid]: fluid
    })

    let onClickProps = {}

    if (onClick) {
      onClickProps = {
        onClick,
        onKeyDown: onClick,
        role: 'button',
        tabIndex: '0'
      }
    }

    return (
      <div
        className={loadClass}
        style={style}
        {...onClickProps} // eslint-disable-line react/jsx-props-no-spreading
      >
        {loading && <img src={loading} alt={alt} className={styles.load} />}

        {tag && (
          <div className={styles.tag}>
            <Chip type="tertiary" color="red" label={tag} />
          </div>
        )}

        <img
          src={imageSrc}
          onError={this.handleFallback}
          alt={alt}
          className={imageClass}
          style={imageStyles}
          onLoad={this.handleLoad}
        />
      </div>
    )
  }
}

Image.defaultProps = {
  src: null,
  loading: null,
  className: null,
  style: {},
  width: null,
  height: null,
  radius: 0,
  fluid: null,
  onClick: null,
  tag: null
}

const { bool, func, string, shape, number, oneOfType } = PropTypes

Image.propTypes = {
  src: string,
  fallback: string.isRequired,
  loading: string,
  className: string,
  style: shape({}),
  alt: string.isRequired,
  width: number,
  height: number,
  radius: oneOfType([number, bool]),
  fluid: bool,
  onClick: func,
  tag: string
}

export default Image
